// OUTLineChartTime_Recharts.tsx
import "./index.css"
import { LineChart, Line, XAxis, YAxis, 
  Legend, CartesianGrid, ResponsiveContainer, Tooltip } from "recharts"
import { outputDataWords, outputDataUnitsWords } from "./swmm_core/wordsnKeys"
import { colorSet01 } from "./swmmjs_module"
import { rechartsFormatXDateAxis } from './swmmreact'

// This is the new problem. I need to read the dataType from the
// parent object, not write it to the parent object. This element
// is only for updating the series object.
const OUTLineChartTime_Recharts = ({values, width='95%', height=250}: any) => {
  
  return (
  <>
  {
    values?.series?.length > 0 &&
    Object.keys(values?.outdir).length > 0 &&
    <ResponsiveContainer width={width} height={height} >
      <LineChart data={values.series}>
        <Tooltip 
          contentStyle={{padding: '5px', margin: '5px 5px 5px 20px'}}
          wrapperStyle={{ outline: 'none' }}
          labelStyle={{fontSize: '0.75em'}}
          itemStyle={{fontSize: '0.75em'}}
          labelFormatter={(d)=>{ return'Date: ' + rechartsFormatXDateAxis(d, 0)}} 
          formatter={(value, name, props)=>[Math.round((parseFloat(value.toString()) + Number.EPSILON)*1000)/1000, name]} />
        <XAxis 
          dataKey='time'
          scale='time'
          type='number'
          domain={ ['auto', 'auto'] }
          style={{ fontSize: '0.75rem' }}
          tickLine={true}
          tickFormatter={rechartsFormatXDateAxis}
          label={{ value: 'Date/Time', position: 'center', dy: 15, fontSize: '0.9rem'}} />
        <YAxis 
          domain={ ['auto', 'auto'] }
          style={{fontSize: "0.75rem"}}
          tickLine={true}
          label={{ value:outputDataWords[values.type][values.dataType] + ", " + outputDataUnitsWords[values.type][values.dataType][values?.outdir?.OpeningRecords?.UnitsSystem](values?.outdir?.OpeningRecords?.FlowUnitCode), angle:-90, position:"center", dx:-30, fontSize:"0.8rem" }} />
        <CartesianGrid stroke="#c6c6c6" />
        <Legend 
          iconType="plainline"
          align="right"
          layout="vertical" 
          verticalAlign="middle"
          wrapperStyle={{ border:"2px solid rgba(50, 50, 120, 0.5)", padding:"0 0.5rem", margin:"0 2rem", top:"10px", right:"-40px", height:"70%", overflow:"auto", fontSize:"0.8em" }} />
        {
          values.objNames
            .map((el:any, i:number)=> 
              <Line
                key={i} 
                name={el}
                dot={false}
                type="monotone" 
                dataKey={el} 
                stroke={colorSet01(i)}
                animationDuration={250}/>
            )
        }
      </LineChart>
    </ResponsiveContainer>
  }
  </>)
}
 
export {OUTLineChartTime_Recharts};